import { useEffect, useState } from 'react';

type useGetTopBuyBoxPositionProps = {
    headerHeight: number;
    buyBoxHeight: number;
};

export const useGetTopBuyBoxPosition = ({
    headerHeight,
    buyBoxHeight,
}: useGetTopBuyBoxPositionProps): { topPosition: number } => {
    const [topPosition, setTopPosition] = useState(0);

    useEffect(() => {
        const handleSidebarScroll = (): void => {
            const marginBottom = 16;
            // the `+5` is to add a little padding to the bottom of the buy box to account for the box shadow
            const shadowHeight = 5;
            const availableSpace = window.innerHeight - headerHeight;
            if (buyBoxHeight > availableSpace) {
                const missingHeight = buyBoxHeight - availableSpace;
                setTopPosition(headerHeight - missingHeight - marginBottom);
            } else {
                setTopPosition(headerHeight + shadowHeight);
            }
        };
        window.addEventListener('scroll', handleSidebarScroll);
        window.addEventListener('resize', handleSidebarScroll);
        handleSidebarScroll();
        return () => {
            window.removeEventListener('scroll', handleSidebarScroll);
            window.removeEventListener('resize', handleSidebarScroll);
        };
    }, [headerHeight, buyBoxHeight]);

    return {
        topPosition,
    };
};
